import Icon from "../icon";
import Translate from "../translate";
import classNames from "classnames";
import { useContext, useMemo } from "react";
import CartContext from "../../context/cart";
import imagePh from "../../images/placeholder-image.png";
import useBreakpoint from "../../hooks/useBreakpoint";

const ConditionalButtonWrapper = ({ isButton, id, onClick, className, children }) => {
  return isButton ? (
    <button id={id} className={className} onClick={onClick}>
      {children}
    </button>
  ) : (
    <div className={className}>{children}</div>
  );
};

const CartCard = ({ item, handleCartSelection, cartRequestMutation }) => {
  const { labels, cartRequest, goToCartDetail } = useContext(CartContext);
  const isMobile = useBreakpoint(575);

  const selectedCart = useMemo(() => cartRequest?.contentId, [cartRequest]);

  return (
    <div
      className={classNames(
        "carrello-content__card",
        item?.id === Number(selectedCart) && "carrello-content__card--selected"
      )}
      key={item?.id}
    >
      <ConditionalButtonWrapper
        className="carrello-content__box"
        isButton={isMobile}
        id={`${item?.id}-btn-mobile`}
        onClick={goToCartDetail}
      >
        <div className="carrello-content__box-image">
          <ConditionalButtonWrapper
            isButton={!isMobile}
            className="carrello-content__img-wrapper"
            id={`${item?.id}-btn-img`}
            onClick={goToCartDetail}
          >
            <img
              src={item?.coverUrl || imagePh}
              className="carrello-content__img"
              alt={item?.title}
            />
          </ConditionalButtonWrapper>
        </div>
        <div
          className={classNames(
            "carrello-content__info",
            !handleCartSelection && "carrello-content__info--review"
          )}
        >
          {isMobile ? (
            <div className="carrello-content__link-content carrello-content__link-content--mobile">
              <h4 className="carrello-content__card-title">
                <Translate text={item?.title} />
              </h4>
              <Icon name="angle-down" />
            </div>
          ) : (
            <h3 className="carrello-content__card-title">
              <Translate text={item?.title} />
            </h3>
          )}
          <div className="carrello-content__intro text">
            <Translate html={item?.description} />
          </div>
          {!isMobile && (
            <button
              className="carrello-content__link-content"
              id={`${item?.id}-view-content`}
              onClick={goToCartDetail}
            >
              <span>{labels?.WELFARE_CART_OPEN_DETAIL || "View content"}</span>
              <Icon name="angle-down" />
            </button>
          )}
        </div>
      </ConditionalButtonWrapper>
      {handleCartSelection && (
        <div className="carrello-content__cta-wrapper">
          <button
            className="button carrello-content__cta secondary"
            id={`${item?.id}-cta`}
            onClick={handleCartSelection}
          >
            {Number(cartRequestMutation.variables?.cartId) === item?.id &&
              cartRequestMutation.isLoading && <span className="loading-spinner" />}
            <span>
              {item?.id === Number(selectedCart)
                ? labels?.WELFARE_SELECTED_CART_CTA || "You've chosen this"
                : labels?.WELFARE_CART_CTA || "Choose this one"}
            </span>
            {item?.id === Number(selectedCart) && (
              <span className="carrello-content__check">
                <Icon name="checkmark" />
              </span>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default CartCard;
